import React from "react";
import {
  dateColumn,
  moneyColumn,
  gstTypeColumn,
  itemCountColumn,
  paymentStatusColumn,
  companyColumn
} from "../../../shared/components/tableColumns.jsx";

const isNonGstInvoice = (inv) => inv.invoiceType === "Normal" || inv.isNonGst;

/** Desktop table columns for the Sales list (cards stay the phone layout). */
export function invoiceColumns({ defaultCompany, showCompany }) {
  return [
    dateColumn("invoiceDate", "Date", (inv) => inv.companyDetails?.dateFormat || defaultCompany?.dateFormat),
    { key: "invoiceNo", label: "Invoice #", width: 120, render: (inv) => <strong>{inv.invoiceNo}</strong> },
    gstTypeColumn(isNonGstInvoice),
    { key: "customerName", label: "Customer" },
    ...(showCompany ? [companyColumn((inv) => inv.companyName || inv.companyDetails?.name)] : []),
    itemCountColumn,
    moneyColumn("grandTotal", "Amount"),
    moneyColumn("balance", "Balance Due", { dashWhenZero: true }),
    paymentStatusColumn
  ];
}
